import { useActivityStore } from '@stores/useActivityStore'
import { View, Text } from 'tamagui'
import { useMemo } from 'react'

export function ActivityDetails() {
  const { activity } = useActivityStore()

  const examQuestionsCount = activity?.examQuestionsCount || 0
  const retryCount = activity?.retryCount || 0
  const maxAttempts = activity?.maxAttempts || 0
  const minGrade = activity?.minGrade || 0

  const result = useMemo(() => {
    if (activity?.examAnswer?.score === 0) return '0'
    return activity?.examAnswer?.score.toFixed(2) || '-'
  }, [activity])

  return (
    <View
      gap="$spacing-inset-xs"
      $gtMd={{
        gap: '$spacing-inset-lg',
        flexDirection: 'row',
      }}
    >
      <View
        backgroundColor="$bg-surface-raised"
        padding="$spacing-inset-xs"
        borderRadius="$border-radius-lg"
        $gtMd={{
          flexDirection: 'row',
          gap: '$spacing-inset-sm',
          justifyContent: 'space-between',
          padding: '$spacing-inset-sm',
          flex: 1,
        }}
      >
        <View flex={1}>
          <Text
            ff="$mulishRegular"
            color="$text-primary"
            fontSize="$font-size-xxxs"
            opacity={0.64}
            lineHeight={18}
          >
            QUANTIDADE DE QUESTÕES
          </Text>
          <Text
            ff="$mulishRegular"
            color="$text-primary"
            fontSize="$font-size-xs"
            fontWeight={600}
            lineHeight={24}
          >
            {examQuestionsCount}
          </Text>
        </View>

        <View
          flexDirection="row"
          flex={1}
          justifyContent="space-between"
          marginTop={20}
          $gtMd={{
            marginTop: 0,
          }}
        >
          <View>
            <Text
              ff="$mulishRegular"
              color="$text-primary"
              fontSize="$font-size-xxxs"
              opacity={0.64}
              lineHeight={18}
            >
              TENTATIVAS
            </Text>
            <Text
              ff="$mulishRegular"
              color="$text-primary"
              fontSize="$font-size-xs"
              fontWeight={600}
              lineHeight={24}
            >
              {retryCount} de {maxAttempts} tentativas
            </Text>
          </View>

          <View>
            <Text
              ff="$mulishRegular"
              color="$text-primary"
              fontSize="$font-size-xxxs"
              opacity={0.64}
              lineHeight={18}
            >
              NOTA MÍNIMA
            </Text>
            <Text
              ff="$mulishBold"
              color="$text-primary"
              fontSize="$font-size-xs"
              fontWeight={600}
              lineHeight={24}
            >
              {minGrade}
            </Text>
          </View>
        </View>
      </View>

      <View
        backgroundColor="$bg-surface-raised"
        padding="$spacing-inset-xs"
        borderRadius="$border-radius-lg"
        $gtMd={{
          padding: '$spacing-inset-sm',
        }}
      >
        <Text
          ff="$mulishRegular"
          color="$text-primary"
          fontSize="$font-size-xxxs"
          opacity={0.64}
          lineHeight={18}
        >
          SEU RESULTADO
        </Text>
        <Text
          ff="$mulishBold"
          color="$text-primary"
          fontSize="$font-size-xs"
          fontWeight={600}
          lineHeight={24}
        >
          {result}
        </Text>
      </View>
    </View>
  )
}
